<template>
    <ob1-popin-modal2 :id="modalId" :aria-labelledby="modalId + '-label'">
        <p :id="modalId + '-label'" class="h4" v-html="energyLabel.popinTitle" />
        <img
            alt=""
            class="w-50"
            :src="energyLabel.labelImage"
        >
        <ob1-liens
            v-if="energyLabel.sheetUrl"
            :with-arrow="true"
            :is-large="true"
            :text="energyLabel.sheetLinkLabel"
            :href="sheetHref"
            :target="'_blank'"
        />
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "EnergyLabelPopin",
    props: {
        modalId: {
            type: String,
            required: true
        },
        energyLabel: {
            type: Object,
            required: true
        }
    },
    computed: {
        sheetHref: function() {
            return this.energyLabel.sheetUrl + "?webview_action=pdf";
        }
    }
};
</script>
